const API_URL = process.env.REACT_APP_BACKEND_URL;

export const fetchProducts = async (category = null) => {
  try {
    const params = new URLSearchParams({ lite: 'true' });
    if (category) params.append('category', category);
    const url = `${API_URL}/api/products?${params.toString()}`;
    
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch products');
    return await response.json();
  } catch (error) {
    console.error('Error fetching products:', error);
    return [];
  }
};

export const fetchProduct = async (handle) => {
  try {
    const response = await fetch(`${API_URL}/api/products/${handle}`);
    if (!response.ok) throw new Error('Failed to fetch product');
    return await response.json();
  } catch (error) {
    console.error('Error fetching product:', error);
    return null;
  }
};

export const fetchCategories = async () => {
  try {
    const response = await fetch(`${API_URL}/api/categories`);
    if (!response.ok) throw new Error('Failed to fetch categories');
    return await response.json();
  } catch (error) {
    console.error('Error fetching categories:', error);
    return [];
  }
};
